import { render, staticRenderFns } from "./alloc-menu.vue?vue&type=template&id=24947e00&scoped=true&"
import script from "./alloc-menu.vue?vue&type=script&lang=ts&"
export * from "./alloc-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24947e00",
  null
  
)

export default component.exports